import WorkContent from "./WorkContent";

export default WorkContent;